<template>
  <div class="container carousel">
    <ProductCarousel
      v-if="personalizationProducts.length"
      :title="title"
      :products="personalizationProducts"
      :on-sale-filter="false"
      :to-send-event="true"
      :container-margin="true"
      :slides-per-view="slidesPerView"
      :space-between="spaceBetween"
    />
  </div>
</template>

<script>
import ProductCarousel from '@/components/commons/ProductCarousel.vue';
import { onBeforeMount } from 'vue';
import usePersonalization from '@/compositions/usePersonalization';

export default {
  name: 'Recommender',
  components: {
    ProductCarousel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    spaceBetween: {
      type: Number,
      default: undefined,
    },
    slidesPerView: {
      type: Number,
      default: undefined,
    },
  },
  setup() {
    const {
      personalizationProducts, //
      loadPersonalizationProducts,
    } = usePersonalization();

    onBeforeMount(() => {
      loadPersonalizationProducts();
    });

    return {
      personalizationProducts,
    };
  },
};
</script>
